import { useEffect, ReactNode } from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { getOrCreateQueryClient, destroyQueryClient } from './iwQueryClient';

export const IwQueryClientProvider = ({
    children
}: {
    children: ReactNode;
}) => {
    useEffect(() => {
        return () => destroyQueryClient();
    });

    return (
        <QueryClientProvider client={getOrCreateQueryClient()}>
            {children}
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    );
};
